import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

const GET_USER_GEO = gql`
  query GetUserGeo($postcode: String!, $country: String!) {
    getUserGeo(postcode: $postcode, country: $country) {
      city
      state
      stateCode
    }
  }
`;

const getCityAndStateForPostcodeAndZipQuery = async ({ variables }) => {
  const { data } = await query({
    query: GET_USER_GEO,
    variables: {
      postcode: variables.postcode,
      country: variables.country,
    },
  });

  return data.getUserGeo;
};

export default getCityAndStateForPostcodeAndZipQuery;
